import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  Tooltip,
  Carousel,
  Icon,
  Pagination,
  Empty,
  message,
  BackTop,
  Select
} from "ant-design-vue";
message.config({
  maxCount: 1
});
Vue.use(Tooltip);
Vue.use(Carousel);
Vue.use(Icon);
Vue.use(Pagination);
Vue.use(Empty);
Vue.use(BackTop);
Vue.use(Select);

import { Tab, Tabs } from "vant";
import { saveChannelParams } from "../stempcore/src/sbase";

Vue.use(Tab);
Vue.use(Tabs);
import "ant-design-vue/dist/antd.css";
import "./assets/scss/index.scss";

import VueI18n from "vue-i18n";

Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.prototype.$message = message;
saveChannelParams();
const i18n = new VueI18n({
  locale: "zh",
  messages: {
    zh: require("@/assets/i18n/zh.json"),
    en: require("@/assets/i18n/en.json")
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
